import { render, staticRenderFns } from "./SalesTrendTab.vue?vue&type=template&id=039c3f24&scoped=true&"
import script from "./SalesTrendTab.vue?vue&type=script&lang=js&"
export * from "./SalesTrendTab.vue?vue&type=script&lang=js&"
import style0 from "./SalesTrendTab.vue?vue&type=style&index=0&id=039c3f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c3f24",
  null
  
)

export default component.exports